import { Textarea as MTextarea } from '@mantine/core';
import classes from './textarea.module.scss';

export const Textarea = MTextarea.extend({
  classNames: classes,
});
